// Detects webpack chunk / dynamic-import load failures and auto-recovers with a
// single guarded reload (re-fetches the failed asset). Guards against reload loops.
const RELOAD_KEY = "lc_chunk_reload";
const MAX_RELOADS = 2;

export function isChunkError(input) {
  if (!input) return false;
  const msg = typeof input === "string" ? input : input.message || String(input);
  return /ChunkLoadError|Loading chunk [\w-]+ failed|Loading CSS chunk|Failed to fetch dynamically imported module|error loading dynamically imported module|import\(\) .*failed/i.test(msg);
}

export function attemptChunkReload() {
  try {
    const n = Number(sessionStorage.getItem(RELOAD_KEY) || "0");
    if (n < MAX_RELOADS) {
      sessionStorage.setItem(RELOAD_KEY, String(n + 1));
      window.location.reload();
      return true;
    }
  } catch {
    window.location.reload();
    return true;
  }
  return false;
}

export function installChunkGuard() {
  if (typeof window === "undefined") return;

  window.addEventListener("error", (e) => {
    const msg = e?.message || e?.error?.message || e?.error;
    if (isChunkError(msg)) {
      e.preventDefault?.();
      attemptChunkReload();
    }
  });

  window.addEventListener("unhandledrejection", (e) => {
    const reason = e?.reason;
    if (isChunkError(reason?.message || reason)) {
      e.preventDefault?.();
      attemptChunkReload();
    }
  });

  // Once the app has run cleanly for a few seconds, clear the reload counter.
  window.addEventListener("load", () => {
    setTimeout(() => {
      try { sessionStorage.removeItem(RELOAD_KEY); } catch { /* no-op */ }
    }, 5000);
  });
}
